import React from "react"
import {Button, Col, FormGroup, FormText, Input, Label, Row} from "reactstrap";

export default class PasswordField extends React.Component {
  handleChange(key, value) {
    this.props.onChange(key, value)
  }
  handleRemove() {
    this.props.onRemove()
  }

  render() {
    return <div>
      {this.props.filename}
      <Row noGutters>
        <Col xs={11}><Input size='sm' type="text" placeholder="Hash.." onChange={(e)=>this.handleChange('hash', e.target.value)} value={this.props.hash}/></Col>
        <Col xs={1}><Button onClick={()=>this.handleRemove(this.props.id)} size='sm' block>-</Button></Col>
      </Row>
      <Input size='sm' type="text" placeholder="Password.." onChange={(e)=>this.handleChange('pass', e.target.value)}/>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/Verification/Actions/PasswordField.js